<style></style>
<template>
    <div id="connections-page">
        <div class="row">
            <div class="col">
                <h3 class="program-information">CONSULTANT INFORMATION</h3>
                <p>
                    <b>{{consultant.first_name}} {{consultant.last_name}} | <a class="primaryDark" v-bind:href="'mailto:'+consultant.email">{{consultant.email}}</a></b>
                </p>

                <p>
                    <b>{{consultant.city}}, {{consultant.state.abbreviation}}, {{consultant.zip}}</b>
                </p>

                <p>
                    Organization Type: <b>{{consultant.organization_type.name}}</b>
                </p>

                <div class="row">
                    <div class="col-md-2">
                        <p>Connections:</p>
                    </div>
                    <div class="col-md-10">
                        <p>
                            <b>{{consultant.connections.length}} Programs Connected</b>
                            <br />
                            <b>{{childrenServed}} Children Served</b>
                        </p>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <div id="consultant-programs-page">
                    <div id="connected-programs">
                        <div class="table-template">
                            <div horizontal label="Filter" class="form-group d-md-none not-generic-form">
                                <div class="input-group">
                                    <select v-model="sortField.key">
                                        <option slot="first" :value="null">-- Filter --</option>
                                        <option v-for="field in sortFields" :value="field.value">{{ field.text }}</option>
                                    </select>
                                    <select :disabled="!sortField.key" v-model="sortDesc" slot="append">
                                        <option :value="false">Asc</option>
                                        <option :value="true">Desc</option>
                                    </select>
                                </div class="input-group">
                            </div class="form-group">

                            <div class="row rounded-top find-program">
                                <div class="arrow-find-program">
                                    <img src="~public@/images/orange_arrow_blue_border.png">
                                    <span class="table-title">&nbsp;Connected Programs</span>
                                </div>
                                <div class="border-search d-none d-md-block">
                                    <div class="input-group">
                                        <input type="text" class="form-control" v-model="filter" placeholder="Type to Search" />
                                        <div class="input-group-append">
                                            <i class="fa fa-search my-auto"></i>
                                        </div>
                                    </div>
                                </div>
                            </div> 

                            <table class="table mb-0">
                                <thead>
                                    <tr>
                                        <th v-for="field in fields" :key="field.key" @click="sortBy(field)" >
                                            {{ field.label }}
                                            <!-- todo: use vue-fontawesome to fix this messy icon toggling logic? -->
                                            <template v-if="field.sortable">
                                                <span v-show="sortField?.key != field.key"><i class="fa fa-sort" aria-hidden="true"></i></span>
                                                <span v-show="sortField && sortField.key == field.key && sortDesc"><i class="fa fa-sort-down" aria-hidden="true"></i></span>
                                                <span v-show="sortField && sortField.key == field.key && !sortDesc"><i class="fa fa-sort-up" aria-hidden="true"></i></span>
                                            </template>

                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="item in paginatedItems">
                                        <td>{{ item.name }}</td>
                                        <td>{{ formatDate(item.created_at) }}</td>
                                        <td>
                                            <div v-if="item.mostRecentAssessment" class="row icon-name-date">
                                                <div class="col-3 connected-icon">
                                                    <div v-bind:class="item.mostRecentAssessment.icon + ' icon-rounded-corners pull-left module-icons-sm bg-'+ item.mostRecentAssessment.color"></div>
                                                </div>
                                                <div class="col connected-name-date">
                                                    <div class="connected-name">{{ item.mostRecentAssessment.name }}</div>
                                                    <div class="connected-date">{{ item.mostRecentAssessment.date }}</div>
                                                </div>
                                            </div>
                                        </td>
                                        <td>
                                            <div v-if="item.mostRecentActionPlan" class="row icon-name-date">
                                                <div class="col-3 connected-icon">
                                                    <div v-bind:class="item.mostRecentActionPlan.icon + ' icon-rounded-corners pull-left module-icons-sm bg-'+ item.mostRecentActionPlan.color"></div>
                                                </div>
                                                <div class="col connected-name-date">
                                                    <div class="connected-name">{{item.mostRecentActionPlan.name}}</div>
                                                    <div class="connected-date">{{item.mostRecentActionPlan.date}}</div>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>

                            <div class="row pagination-row justify-content-center">
                                <nav aria-label="Page navigation for list of Connected Programs">
                                    <ul class="pagination" role="menubar">
                                        <li class="page-item">
                                            <a class="page-link" @click="prevPage" aria-label="Go to previous page">&lt;</a>
                                        </li>
                                        <li v-for="pageNum in pageCount" class="page-item" :class="{active: pageNum == currentPage}" :aria-label="`Go to page ${pageNum}`">
                                            <a class="page-link" @click="setPage(pageNum)">{{ pageNum }}</a>
                                        </li>
                                        <li class="page-item">
                                            <a class="page-link" @click="nextPage" aria-label="Go to next page">&gt;</a>
                                        </li>
                                    </ul>
                                </nav>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <br />
        <div class="row">
            <div class="col">
                <p>
                    &nbsp;&nbsp;&nbsp;<a :href="$basePath+'/dashboard'" class="more-information"><i class="fas fa-caret-left"></i> Back To All Consultants</a>
                </p>
            </div>
        </div>
    </div>
</template>

<script>
    import moment from 'moment'
    export default {
        props: {
            consultant: {
                type: Object,
                required: true
            }
        },
        data() {
            return {
                filter: null,
                fields: [
                    {
                        key: 'name',
                        label: 'Program Name',
                        sortable: true,
                        compareFn: this.compareString
                    },
                    {
                        key: 'created_at',
                        label: 'Date Joined',
                        sortable: true,
                        compareFn: this.compareDate
                    },
                    {
                        key: 'mostRecentAssessment',
                        label: 'Most Recent Self-Assessment',
                        sortable: false
                    },
                    {
                        key: 'mostRecentActionPlan',
                        label: 'Most Recent Action Plan',
                        sortable: false
                    }
                ],
                currentPage: 1,
                perPage: 3,
                sortField:
                {
                    key: null,
                    label: null,
                    sortable: false,
                    compareFn: undefined
                },
                sortDesc: false,
                loading: true
                }
        },
        methods:{
            // onFiltered (filteredItems) {
            //     // Trigger pagination to update the number of buttons/pages due to filtering
            //     this.totalRows = filteredItems.length
            //     this.currentPage = 1
            // },
            formatDate(date){
                return moment(date).format('M/D/Y')
            },
            setPage: function(page) {
                this.currentPage = page;
            },
            nextPage: function() {
                if(this.currentPage >= this.pageCount) {
                    this.currentPage = this.pageCount;
                } else {
                    this.currentPage++;
                }
            },
            prevPage: function() {
                if(this.currentPage <= 1) {
                    this.currentPage = 1;
                } else {
                    this.currentPage--;
                }
            },
            resetPage: function() {
                this.setPage(1);
            },
            sortBy(field) {
                if(field.sortable) {
                    if(field.key === this.sortField.key) {
                        this.toggleSortDir();
                    } else {
                        this.sortDesc = false;
                    }
                    this.sortField = field;
                    this.resetPage();
                }
            },
            toggleSortDir() {
                this.sortDesc = !this.sortDesc
            },
            compareString: function(a, b) {
                if(a[this.sortField.key] < b[this.sortField.key])
                    return -1;
                if(a[this.sortField.key] > b[this.sortField.key])
                    return 1;

                return 0;
            },
            compareDate: function(a, b) {
                let aDate = new Date(a[this.sortField.key]);
                let bDate = new Date(b[this.sortField.key]);

                return aDate - bDate;
            }
        },
        computed: {
            sortFields: function () {
                if (this.fields) {
                    return this.fields
                        .filter(f => f.sortable)
                        .map(f => { return { text: f.label, value: f.key } })
                }
                return new Array();
            },
            childrenServed: function() {
                var children = 0
                for (var i = 0; i < this.consultant.connections.length; i++) {
                    children += this.consultant.connections[i].children
                } 
                return children
            },
            pageCount: function() {
                return Math.ceil(this.consultant?.connections?.length/this.perPage);
            },
            paginatedItems: function() {
                let start = (this.currentPage-1) * this.perPage;
                return this.sortedItems.slice(start, start + this.perPage);
            },
            sortedItems: function() {
                let sortedItems = this.consultant.connections;

                if(this.sortField) {
                    sortedItems = sortedItems.toSorted(this.sortField.compareFn);
                    sortedItems = this.sortDesc ? sortedItems.toReversed() : sortedItems ;
                }

                return sortedItems;
            },
        },
        watch: {
            /**
             * Set remainder of sortField keys when sort dropdown is selected
             */
            "sortField.key"(newValue) {
                let newSortField = this.fields.find((field) => {
                    return field.key === newValue;
                });
                Object.assign(this.sortField,  { ...newSortField });
            }
        }
    }
</script>